<template>
    <div ref="container">
      <a-modal :title="title" width="96%" height="90%" :visible="visible" :confirmLoading="confirmLoading"
      :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()"
      :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:1%;height: 70%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="售后服务单号" prop="code">
                  <a-input placeholder="请输入售后服务单号" v-model="form.code"/>
                  <!-- onblur="isRepeat" -->
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务日期" prop="date">
                  <JDate placeholder="请填写服务日期" v-model="form.date" ></JDate>
                </a-form-model-item>
              </a-col>
              <!-- <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="审核人" prop="reviewer">
                  <a-input placeholder="请输入审核人" v-model="form.reviewer" />
                </a-form-model-item>
              </a-col> -->
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="受理人" prop="acceptedBy">
                  <a-input placeholder="请输入受理人" v-model="form.acceptedBy" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="购货者" prop="buyer">
                  <a-input placeholder="请输入购货者" v-model="form.buyer" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人" prop="contacts">
                  <a-input placeholder="请输入联系人" v-model="form.contacts" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话" prop="contactsPhoneNumber">
                  <a-input placeholder="请输入联系电话" v-model="form.contactsPhoneNumber" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="服务内容" prop="service">
                  <a-textarea placeholder="请输入服务内容" v-model="form.service" :autoSize="{ minRows: 3 }"></a-textarea>
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品编号" prop="productNumber">
                  <a-input placeholder="请输入产品编号" v-model="form.productNumber" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品名称" prop="productName">
                  <a-input placeholder="请输入产品名称" v-model="form.productName" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品数量" prop="productNum">
                  <a-input placeholder="请输入产品数量" v-model="form.productNum" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="维护人员" prop="keeper">
                  <a-input placeholder="请输入维护人员" v-model="form.keeper" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="维护工时" prop="keepTime">
                  <a-input placeholder="请输入维护工时" v-model="form.keepTime" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" prop="remark">
                  <a-input placeholder="请输入备注" v-model="form.remark" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系地址" prop="address">
                  <a-input placeholder="请输入联系地址" v-model="form.address" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="有无不良事件发生" prop="isBad">
                  <a-input placeholder="请输入有无不良事件发生" v-model="form.isBad" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上次回访日期" prop="preDate">
                  <JDate placeholder="请填写上次回访日期" v-model="form.preDate" ></JDate>
                </a-form-model-item>
              </a-col>
              <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="维护记录" prop="keepRemark">
                  <a-textarea placeholder="请输入维护记录" v-model="form.keepRemark" :autoSize="{ minRows: 3 }"></a-textarea>
                </a-form-model-item>
              </a-col>
              <!-- <a-col :span="12/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                  <j-image-upload v-model="fileList" bizPath="material" text="上传" isMultiple></j-image-upload>
                </a-form-model-item>
              </a-col> -->
            </a-row>
          </a-form-model>
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import pick from 'lodash.pick'
  import { addAfterService, editAfterService, generateCode } from '@/api/api'
  import { autoJumpNextInput } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
import JDate from '../../../components/jeecg/JDate.vue'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
        JImageUpload,
        JDate,
    },
    data() {
      return {
        title: '操作',
        visible: false,
        fileList: '',
        model: {},
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        form: {
          code: '',
        },
        uploadHeaders: {},
        action: window._CONFIG['domianURL'] + '/systemConfig/upload',
        rules: {
          code: [{ required: true, message: '请输入单据编号' }],
          date: [{ required: true, message: '请选择单据日期' }],
          department: [{ required: true, message: '请输入申请部门' }],
          preparedBy: [{ required: true, message: '请输入制单人' }],
          preparedTime: [{ required: true, message: '请输入单据时间' }],
        },
        id: '',
      }
    },
    created() {},
    methods: {
      //单据编号验重
      isRepeat(){
        console.log('000')
      },
      add() {
        this.resetForm()
        this.generateCode()
        this.edit({})
        this.id = ''
      },
      edit(record) {
        
        console.log(this.$refs.form, 'this.$refs.form================')
        if (this.$refs.form !== undefined) this.$refs.form.resetFields()
        console.log(this.form, 'form')
        console.log(this.fileList, '数组')
        if (record.id) {
          this.id = record.id
          this.form = { ...this.form, ...record } // 合并保留初始字段
        } else {
          this.fileList = ''
          // 重置表单但保留初始结构
          this.resetForm()
          // this.form = Object.assign({}, this.$options.data().form)
          // this.form = JSON.parse(JSON.stringify(this.$options.data().form))
        }
        this.visible = true
        this.$nextTick(() => {})
      },
      // 重置表单
      resetForm() {
        this.form = {
                code: '',
                date: '',
                acceptedBy: '',
                buyer: '',
                contacts: '',
                reviewer: '',
                contactsPhoneNumber: '',
                service: '',
                productNumber: '',
                productName: '',
                productNum: '',
                keeper: '',
                keepTime: '',
                remark: '',
                address: '',
                isBad: '',
                preDate: '',
                keepRemark: '',
            }
            this.id = ''
      },
      
      // 生成单号
      generateCode(){
        generateCode().then(res => {
          if (res.code == 200 && res.success == true) {
            this.form.code = res.result
          } else {
            this.$message.error(res.message)
          }
        })

      },
      handleChange({ file, fileList }) {
        console.log(file, 'file')
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            console.log(this.form, 'form---')
            debugger
            // console.log(this.fileList, '图片数组')
            // if (this.fileList.length == 0) return this.$message.warning('请上传至少一张图片')
            let params = {
                code: this.form.code || '',
                date: this.form.date || '',
                acceptedBy: this.form.acceptedBy || '',
                buyer: this.form.buyer || '',
                contacts: this.form.contacts || '',
                reviewer: this.form.reviewer || '',
                contactsPhoneNumber: this.form.contactsPhoneNumber || '',
                service: this.form.service || '',
                productNumber: this.form.productNumber || '',
                productName: this.form.productName || '',
                productNum: this.form.productNum || '',
                keeper: this.form.keeper || '',
                keepTime: this.form.keepTime || '',
                remark: this.remark || '',
                address: this.form.address || '',
                isBad: this.form.isBad || '',
                preDate: this.form.preDate || '',
                keepRemark: this.form.keepRemark || '',
            }
            if (this.id) {
              
              // 编辑
              params.id = this.id
              const res = await editAfterService(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message({
                  message: res.result,
                  type: 'success',
                });
                this.handleCancel()
                this.$emit('ok')
                // 把form 清空
                this.$refs['form'].resetFields()
              } else {
                this.$message.error(res.result)
              }
            } else {
              const res = await addAfterService(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.message)
                this.close()
                this.$emit('ok')
                this.$refs['form'].resetFields()
                this.id = ''
              } else {
                this.$message.error(res.data || res.message)
              }
            }
          }
        })
      },
      handleCancel() {
        this.close()
      },
      validateSupplierName(rule, value, callback) {
        let params = {
          name: value,
          type: '供应商',
          id: this.model.id ? this.model.id : 0,
        }
        checkSupplier(params).then((res) => {
          if (res && res.code === 200) {
            if (!res.data.status) {
              callback()
            } else {
              callback('名称已经存在')
            }
          } else {
            callback(res.data)
          }
        })
      },
    },
  }
  </script>
  <style scoped>
  </style>